import { AxiosError } from 'axios';

export const handleApiError = (err: unknown) => {
  const e = err as AxiosError<any>;
  return e?.response?.data?.message || 'Something went wrong on our end';
};
